import LoadingPageComponent from "./loadingPageComponent";
export default LoadingPageComponent;